import React from 'react';
import PropTypes from 'prop-types';
import includes from 'lodash/includes';
import { DataTableListItem } from '@eventbrite/eds-data-table-list-item';
import {
    DISABLED_ITEMS_PROP_TYPE,
    HIGHLIGHTED_ITEMS_PROP_TYPE,
    ITEMS_PROP_TYPE,
    SELECTED_ITEMS_PROP_TYPE,
} from './constants';
import { COLUMNS_PROP_TYPE } from '@eventbrite/eds-data-table-list-item';
import { TEXT_ITEMS_PROP_TYPE } from '@eventbrite/eds-text-list';

export default class DataTableList extends React.PureComponent {
    static propTypes = {
        /**
         * The list of of items that should be rendered in the table at the given time.
         **/
        items: ITEMS_PROP_TYPE.isRequired,
        /**
         * The column names and editable information for each item
         **/
        columns: COLUMNS_PROP_TYPE.isRequired,
        /**
         * Array of items ID to disable each row
         **/
        disabledItems: DISABLED_ITEMS_PROP_TYPE,
        /**
         * Array of items ID to highlight each row
         **/
        highlightedItems: HIGHLIGHTED_ITEMS_PROP_TYPE,
        /**
         * Whether or not the items in the given list are selectable or not.
         **/
        isSelectable: PropTypes.bool,
        /**
         * The ids of the items that have already been selected. Each id should match
         * the `id` prop of one of the items in the `items` array.
         **/
        selectedItemIds: SELECTED_ITEMS_PROP_TYPE,
        /**
         * Callback for each itemAction. Will receive the item object and the action ie.
         * ('delete', {name: Vincent, id: 1}) => {}
         **/
        onItemAction: PropTypes.func,
        /**
         * List of actions that should be available for each DataTableListItem
         **/
        actions: TEXT_ITEMS_PROP_TYPE,
        /**
         * This function will optionally filter out actions based on action and item
         */
        filterAction: PropTypes.func,
    };

    static defaultProps = {
        highlightedItems: [],
        isSelectable: false,
        disabledItems: [],
    };

    _getDataTableListItems() {
        const {
            actions,
            filterAction,
            columns,
            disabledItems,
            highlightedItems,
            isSelectable,
            items,
            onItemAction,
            selectedItemIds,
            isWideColumn,
            noBorderForTableRow,
            isTableListItemHover,
        } = this.props;

        return items.map((item) => {
            const isSelected = includes(selectedItemIds, item.id);
            const isHighlighted = includes(highlightedItems, item.id);
            const isDisabled = includes(disabledItems, item.id);
            const filteredActions = filterAction
                ? actions.filter((action) => filterAction(action, item))
                : actions;

            return (
                <DataTableListItem
                    key={item.id}
                    actions={filteredActions}
                    columns={columns}
                    isDisabled={isDisabled}
                    isHighlighted={isHighlighted}
                    isSelectable={isSelectable}
                    isSelected={isSelected}
                    item={item}
                    onAction={onItemAction}
                    isTableListItemHover={isTableListItemHover}
                    isWideColumn={isWideColumn}
                    noBorderForTableRow={noBorderForTableRow}
                />
            );
        });
    }

    render() {
        const dataTableListItems = this._getDataTableListItems();

        return <tbody className="eds-table-list">{dataTableListItems}</tbody>;
    }
}
